import { Caption } from '@casavo/base-ui'
import cn from 'classnames'
import { useField } from 'formik'
import React from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

import { checkboxSubtext, formikCheckbox, formikCheckboxCaption } from './styles.css'

type Props = {
  center?: boolean
  className?: string
  handleTracking?: () => void
  id: string
  label: string | React.ReactNode
  name: string
  required?: boolean
  subText?: React.ReactNode
}

export const FormikCheckbox: React.FC<Props> = ({
  center = true,
  className,
  handleTracking,
  id,
  label,
  name,
  required,
  subText,
}) => {
  const [field, meta] = useField({ name })
  const { onChange, value } = field
  const { error } = meta

  return (
    <div
      className={cn(
        className,
        sprinkles({
          display: 'flex',
          justifyContent: center ? 'center' : 'flex-start',
          marginBottom: 's',
          userSelect: 'none',
        })
      )}
    >
      <input
        checked={value}
        className={error ? formikCheckbox.error : formikCheckbox.default}
        data-testid={`checkbox-${id}`}
        id={id}
        name={name}
        required={required}
        type="checkbox"
        onChange={(e: React.FormEvent<HTMLInputElement>) => {
          onChange(e)
          typeof handleTracking === 'function' && handleTracking()
        }}
      />
      <div className={sprinkles({ marginLeft: 'm' })}>
        <Caption strong as="label" className={cn(formikCheckboxCaption, sprinkles({ cursor: 'pointer' }))} htmlFor={id}>
          {required ? `${label} *` : label}
        </Caption>
        <div className={checkboxSubtext}>{subText}</div>
      </div>
    </div>
  )
}
